export const locations = [
    {
      slug: 'boulder',
      city: 'Boulder',
      state: 'CO',
      schools: ['Boulder High School', 'Fairview High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Boulder, CO'
    },
    {
      slug: 'denver',
      city: 'Denver',
      state: 'CO',
      schools: ['East High School', 'Denver South High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Denver, CO. Join our successful Mile High City students!'
    },
    {
      slug: 'oakpark',
      city: 'Oak Park',
      state: 'IL',
      schools: ['Fort Collins High School', 'Rocky Mountain High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Oak Park, IL.'
    },
    {
      slug: 'milton',
      city: 'Milton',
      state: 'GA',
      schools: ['Milton High School', 'Rocky Mountain High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Milton, GA.'
    },
    {
      slug: 'syracuse',
      city: 'Syracuse',
      state: 'NY',
      schools: ['Henninger High School', 'Corcoran High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Syracuse, NY.'
    },
    {
      slug: 'fort-collins',
      city: 'Fort Collins',
      state: 'CO',
      schools: ['Fort Collins High School', 'Poudre High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Fort Collins, CO.'
    },
    {
      slug: 'salem',
      city: 'Salem',
      state: 'OR',
      schools: ['South Salem High School', 'North Salem High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Salem, OR.'
    },
    {
      slug: 'springfield',
      city: 'Springfield',
      state: 'MO',
      schools: ['Central High School', 'Kickapoo High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Springfield, MO.'
    },
    {
      slug: 'alexandria',
      city: 'Alexandria',
      state: 'VA',
      schools: ['T.C. Williams High School', 'Bishop Ireton High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Alexandria, VA.'
    },
    {
      slug: 'gainesville',
      city: 'Gainesville',
      state: 'FL',
      schools: ['Gainesville High School', 'Buchholz High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Gainesville, FL.'
    },
    {
      slug: 'providence',
      city: 'Providence',
      state: 'RI',
      schools: ['Classical High School', 'Central High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Providence, RI.'
    },
    {
      slug: 'norman',
      city: 'Norman',
      state: 'OK',
      schools: ['Norman High School', 'Norman North High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Norman, OK.'
    },
    {
      slug: 'charleston',
      city: 'Charleston',
      state: 'SC',
      schools: ['Burke High School', 'West Ashley High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Charleston, SC.'
    },
    {
      slug: 'richmond',
      city: 'Richmond',
      state: 'VA',
      schools: ['Thomas Jefferson High School', 'Richmond Community High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Richmond, VA.'
    },
    {
      slug: 'raleigh',
      city: 'Raleigh',
      state: 'NC',
      schools: ['Enloe High School', 'Broughton High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Raleigh, NC. Join our Research Triangle students!'
  },
  {
      slug: 'mesa',
      city: 'Mesa',
      state: 'AZ',
      schools: ['Mountain View High School', 'Red Mountain High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Mesa, AZ.'
  },
  {
      slug: 'omaha',
      city: 'Omaha',
      state: 'NE',
      schools: ['Westside High School', 'Central High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Omaha, NE.'
  },
  {
      slug: 'tulsa',
      city: 'Tulsa',
      state: 'OK',
      schools: ['Booker T. Washington High School', 'Edison Preparatory School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Tulsa, OK.'
  },
  {
      slug: 'worcester',
      city: 'Worcester',
      state: 'MA',
      schools: ['Worcester Technical High School', 'Doherty Memorial High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Worcester, MA.'
  },
  {
      slug: 'boise',
      city: 'Boise',
      state: 'ID',
      schools: ['Boise High School', 'Timberline High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Boise, ID.'
  },
  {
      slug: 'fort-wayne',
      city: 'Fort Wayne',
      state: 'IN',
      schools: ['Northrop High School', 'Snider High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Fort Wayne, IN.'
  },
  {
      slug: 'spokane',
      city: 'Spokane',
      state: 'WA',
      schools: ['Lewis and Clark High School', 'Ferris High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Spokane, WA.'
  },
  {
      slug: 'madison',
      city: 'Madison',
      state: 'WI',
      schools: ['West High School', 'Memorial High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Madison, WI.',
      spotlight: {
          title: "Madison Students Excel in a Vibrant, College-Driven City",
          description: "Home to one of the nation’s top public universities, Madison is an academic hub where students benefit from cultural richness, strong public education, and a progressive learning environment.",
          keyPoints: [
            "Madison Metropolitan School District offers advanced learning and honors programs",
            "High community engagement and support for education equity",
            "Access to university-level research and academic events",
            "Progressive policies promoting college and career readiness"
          ],
          colleges: [
            {
              name: "University of Wisconsin–Madison",
              url: "https://www.wisc.edu/",
              description: "Flagship public university ranked among the top 10 U.S. public institutions."
            },
            {
              name: "Edgewood College",
              url: "https://www.edgewood.edu/",
              description: "Private liberal arts college near downtown Madison with small class sizes."
            },
            {
              name: "Madison Area Technical College (Madison College)",
              url: "https://madisoncollege.edu/",
              description: "Community college with career-focused and transfer pathways."
            },
            {
              name: "Beloit College",
              url: "https://www.beloit.edu/",
              description: "Liberal arts college about an hour from Madison known for its experiential education model."
            }
          ]
          }
},
  {
      slug: 'des-moines',
      city: 'Des Moines',
      state: 'IA',
      schools: ['Roosevelt High School', 'Valley High School'],
      metaDescription: 'Best AI-powered SAT® prep platform in Des Moines, IA.'
  },
  {
    slug: 'knoxville',
    city: 'Knoxville',
    state: 'TN',
    schools: ['Farragut High School', 'Bearden High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Knoxville, TN.'
},
{
    slug: 'grand-rapids',
    city: 'Grand Rapids',
    state: 'MI',
    schools: ['East Grand Rapids High School', 'Forest Hills Central High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Grand Rapids, MI.'
},
{
    slug: 'winston-salem',
    city: 'Winston-Salem',
    state: 'NC',
    schools: ['Mount Tabor High School', 'Reynolds High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Winston-Salem, NC.'
},
{
    slug: 'huntsville',
    city: 'Huntsville',
    state: 'AL',
    schools: ['Huntsville High School', 'Grissom High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Huntsville, AL.'
},
{
    slug: 'salt-lake-city',
    city: 'Salt Lake City',
    state: 'UT',
    schools: ['West High School', 'Highland High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Salt Lake City, UT.'
},
{
    slug: 'eugene',
    city: 'Eugene',
    state: 'OR',
    schools: ['South Eugene High School', 'Sheldon High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Eugene, OR.'
},
{
    slug: 'ann-arbor',
    city: 'Ann Arbor',
    state: 'MI',
    schools: ['Pioneer High School', 'Huron High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Ann Arbor, MI.'
},
{
    slug: 'fort-myers',
    city: 'Fort Myers',
    state: 'FL',
    schools: ['Fort Myers High School', 'Canterbury School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Fort Myers, FL.'
},
{
    slug: 'bellevue',
    city: 'Bellevue',
    state: 'WA',
    schools: ['Bellevue High School', 'Newport High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Bellevue, WA.'
},
{
    slug: 'naperville',
    city: 'Naperville',
    state: 'IL',
    schools: ['Naperville North High School', 'Naperville Central High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Naperville, IL.'
},
{
    slug: 'lexington',
    city: 'Lexington',
    state: 'KY',
    schools: ['Henry Clay High School', 'Paul Laurence Dunbar High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Lexington, KY.'
},
{
    slug: 'cary',
    city: 'Cary',
    state: 'NC',
    schools: ['Cary High School', 'Green Hope High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Cary, NC.'
},
{
    slug: 'columbia',
    city: 'Columbia',
    state: 'SC',
    schools: ['A.C. Flora High School', 'Dreher High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Columbia, SC.'
},
{
    slug: 'greensboro',
    city: 'Greensboro',
    state: 'NC',
    schools: ['Grimsley High School', 'Page High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Greensboro, NC.'
},
{
    slug: 'rochester',
    city: 'Rochester',
    state: 'NY',
    schools: ['Brighton High School', 'Pittsford Sutherland High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Rochester, NY.'
},
{
    slug: 'provo',
    city: 'Provo',
    state: 'UT',
    schools: ['Provo High School', 'Timpview High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Provo, UT.'
},
{
    slug: 'greenville',
    city: 'Greenville',
    state: 'SC',
    schools: ['Greenville High School', 'J.L. Mann High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Greenville, SC.'
},
{
    slug: 'vancouver',
    city: 'Vancouver',
    state: 'WA',
    schools: ['Skyview High School', 'Columbia River High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Vancouver, WA.'
},
{
    slug: 'bend',
    city: 'Bend',
    state: 'OR',
    schools: ['Bend Senior High School', 'Summit High School'],
    metaDescription: 'Best AI-powered SAT® prep platform in Bend, OR.'
}, 
{
  slug: 'durham',
  city: 'Durham',
  state: 'NC',
  schools: ['Durham Academy', 'Jordan High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Durham, NC. Join our Research Triangle students!'
},
{
  slug: 'austin',
  city: 'Austin',
  state: 'TX',
  schools: ['Austin High School', 'Westlake High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Austin, TX.'
},
{
  slug: 'princeton',
  city: 'Princeton',
  state: 'NJ',
  schools: ['Princeton High School', 'Stuart Country Day School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Princeton, NJ.'
},
{
  slug: 'cambridge',
  city: 'Cambridge',
  state: 'MA',
  schools: ['Cambridge Rindge and Latin School', 'Buckingham Browne & Nichols School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Cambridge, MA.',
  spotlight: {
    title: "Where Innovation Meets Education",
    description: "Cambridge, home to Harvard and MIT, creates a unique academic environment where students are surrounded by world-class educational resources.",
    keyPoints: [
      "Historic academic excellence tradition",
      "Access to university resources and programs",
      "Diverse international student population",
      "Strong college preparatory culture"
    ]
  }
},
{
  slug: 'palo-alto',
  city: 'Palo Alto',
  state: 'CA',
  schools: ['Palo Alto High School', 'Gunn High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Palo Alto, CA.',
  spotlight: {
    title: "Silicon Valley's Educational Hub",
    description: "Home to Stanford University and nestled in the heart of Silicon Valley, Palo Alto's academic excellence is reflected in its consistently high SAT scores. Students here balance rigorous academics with innovation, preparing for top universities nationwide.",
    keyPoints: [
      "Consistently ranked among top school districts in California",
      "Strong STEM focus with direct access to Silicon Valley opportunities",
      "Average SAT scores significantly above national average",
      "High percentage of students attending top-tier universities"
    ]
  }
},
{
  slug: 'greenwich',
  city: 'Greenwich',
  state: 'CT',
  schools: ['Greenwich High School', 'Brunswick School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Greenwich, CT.'
},
{
  slug: 'bethesda',
  city: 'Bethesda',
  state: 'MD',
  schools: ['Walt Whitman High School', 'Bethesda-Chevy Chase High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Bethesda, MD.'
},
{
  slug: 'newton',
  city: 'Newton',
  state: 'MA',
  schools: ['Newton North High School', 'Newton South High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Newton, MA.'
},
{
  slug: 'mclean',
  city: 'McLean',
  state: 'VA',
  schools: ['McLean High School', 'Langley High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in McLean, VA.'
},
{
  slug: 'wellesley',
  city: 'Wellesley',
  state: 'MA',
  schools: ['Wellesley High School', 'Dana Hall School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Wellesley, MA.'
},
{
  slug: 'westport',
  city: 'Westport',
  state: 'CT',
  schools: ['Staples High School', 'Greens Farms Academy'],
  metaDescription: 'Best AI-powered SAT® prep platform in Westport, CT.'
},
{
  slug: 'scarsdale',
  city: 'Scarsdale',
  state: 'NY',
  schools: ['Scarsdale High School', 'Edgemont Junior/Senior High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Scarsdale, NY.'
},
{
  slug: 'los-altos',
  city: 'Los Altos',
  state: 'CA',
  schools: ['Los Altos High School', 'Mountain View High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Los Altos, CA.'
},
{
  slug: 'winnetka',
  city: 'Winnetka',
  state: 'IL',
  schools: ['New Trier High School', 'North Shore Country Day School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Winnetka, IL.'
},
{
  slug: 'evanston',
  city: 'Evanston',
  state: 'IL',
  schools: ['Evanston Township High School', 'Roycemore School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Evanston, IL.'
},
{
  slug: 'brookline',
  city: 'Brookline',
  state: 'MA',
  schools: ['Brookline High School', 'Dexter Southfield School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Brookline, MA.'
},
{
  slug: 'short-hills',
  city: 'Short Hills',
  state: 'NJ',
  schools: ['Millburn High School', 'Newark Academy'],
  metaDescription: 'Best AI-powered SAT® prep platform in Short Hills, NJ.'
},
{
  slug: 'great-neck',
  city: 'Great Neck',
  state: 'NY',
  schools: ['Great Neck South High School', 'Great Neck North High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Great Neck, NY.'
},
{
  slug: 'darien',
  city: 'Darien',
  state: 'CT',
  schools: ['Darien High School', "St. Luke's School"],
  metaDescription: 'Best AI-powered SAT® prep platform in Darien, CT.'
},
{
  slug: 'highland-park',
  city: 'Highland Park',
  state: 'TX',
  schools: ['Highland Park High School', 'Hockaday School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Highland Park, TX.'
},
{
  slug: 'piedmont',
  city: 'Piedmont',
  state: 'CA',
  schools: ['Piedmont High School', 'Millennium High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Piedmont, CA.'
},
{
  slug: 'bronxville',
  city: 'Bronxville',
  state: 'NY',
  schools: ['Bronxville High School', 'The Masters School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Bronxville, NY.'
},
{
  slug: 'lake-forest',
  city: 'Lake Forest',
  state: 'IL',
  schools: ['Lake Forest High School', 'Lake Forest Academy'],
  metaDescription: 'Best AI-powered SAT® prep platform in Lake Forest, IL.'
},
{
  slug: 'orinda',
  city: 'Orinda',
  state: 'CA',
  schools: ['Miramonte High School', 'Orinda Academy'],
  metaDescription: 'Best AI-powered SAT® prep platform in Orinda, CA.'
},
{
  slug: 'rye',
  city: 'Rye',
  state: 'NY',
  schools: ['Rye High School', 'Rye Country Day School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Rye, NY.'
},
{
  slug: 'potomac',
  city: 'Potomac',
  state: 'MD',
  schools: ['Winston Churchill High School', 'Bullis School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Potomac, MD.'
},
{
  slug: 'hillsborough',
  city: 'Hillsborough',
  state: 'CA',
  schools: ['Crystal Springs Uplands School', 'The Nueva School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Hillsborough, CA.'
},
{
  slug: 'chappaqua',
  city: 'Chappaqua',
  state: 'NY',
  schools: ['Horace Greeley High School', 'The Hackley School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Chappaqua, NY.'
},
{
  slug: 'atherton',
  city: 'Atherton',
  state: 'CA',
  schools: ['Menlo-Atherton High School', 'Sacred Heart Schools'],
  metaDescription: 'Best AI-powered SAT® prep platform in Atherton, CA.'
},
{
  slug: 'wayne',
  city: 'Wayne',
  state: 'PA',
  schools: ['Radnor High School', 'Valley Forge Military Academy'],
  metaDescription: 'Best AI-powered SAT® prep platform in Wayne, PA.'
},
{
  slug: 'glencoe',
  city: 'Glencoe',
  state: 'IL',
  schools: ['New Trier High School', 'North Shore Country Day School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Glencoe, IL.'
},
{
  slug: 'la-jolla',
  city: 'La Jolla',
  state: 'CA',
  schools: ['La Jolla High School', "The Bishop's School"],
  metaDescription: 'Best AI-powered SAT® prep platform in La Jolla, CA.'
},
{
  slug: 'devon',
  city: 'Devon',
  state: 'PA',
  schools: ['Conestoga High School', 'Devon Preparatory School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Devon, PA.',
    spotlight:{
          title: "Devon Students Thrive in One of Pennsylvania’s Premier Districts",
          description: "Located on the Philadelphia Main Line, Devon offers elite academic opportunities through Tredyffrin/Easttown schools, strong college prep culture, and easy access to many top universities.",
          keyPoints: [
            "Part of the nationally ranked Tredyffrin/Easttown School District",
            "High SAT averages and elite college placement record",
            "Emphasis on writing, research, and interdisciplinary programs",
            "Access to rich cultural and academic resources in the Philly metro"
          ],
          colleges: [
            {
              name: "Villanova University",
              url: "https://www.villanova.edu/",
              description: "A top-ranked private university known for business, law, and liberal arts."
            },
            {
              name: "University of Pennsylvania",
              url: "https://www.upenn.edu/",
              description: "Ivy League university about 30 minutes away, with elite undergraduate and graduate programs."
            },
            {
              name: "West Chester University",
              url: "https://www.wcupa.edu/",
              description: "Public university with strong education and performing arts departments."
            },
            {
              name: "Swarthmore College",
              url: "https://www.swarthmore.edu/",
              description: "Highly selective liberal arts college focused on intellectual rigor and community."
            }
          ]
        }

},
{
  slug: 'summit',
  city: 'Summit',
  state: 'NJ',
  schools: ['Summit High School', 'Kent Place School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Summit, NJ.'
},
{
  slug: 'seoul',
  city: 'Seoul',
  state: 'South Korea',
  schools: ['Seoul International School', 'Korea International School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Seoul, South Korea.'
},
{
  slug: 'hong-kong',
  city: 'Hong Kong',
  state: 'Hong Kong',
  schools: ['Hong Kong International School', 'Chinese International School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Hong Kong.'
},
{
  slug: 'singapore',
  city: 'Singapore',
  state: 'Singapore',
  schools: ['Singapore American School', 'United World College'],
  metaDescription: 'Best AI-powered SAT® prep platform in Singapore.'
},
{
  slug: 'mumbai',
  city: 'Mumbai',
  state: 'India',
  schools: ['American School of Bombay', 'Dhirubhai Ambani International School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Mumbai, India.'
},
{
  slug: 'dubai',
  city: 'Dubai',
  state: 'UAE',
  schools: ['Dubai American Academy', 'American School of Dubai'],
  metaDescription: 'Best AI-powered SAT® prep platform in Dubai, UAE.'
},
{
  slug: 'taipei',
  city: 'Taipei',
  state: 'Taiwan',
  schools: ['Taipei American School', 'Dominican International School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Taipei, Taiwan.'
},
{
  slug: 'bangkok',
  city: 'Bangkok',
  state: 'Thailand',
  schools: ['International School Bangkok', 'Bangkok Patana School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Bangkok, Thailand.'
},
{
  slug: 'tel-aviv',
  city: 'Tel Aviv',
  state: 'Israel',
  schools: ['American International School', 'Walworth Barbour American International School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Tel Aviv, Israel.'
},
{
  slug: 'burbank',
  city: 'Burbank',
  state: 'CA',
  schools: ['Burbank High School', 'John Burroughs High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Burbank, CA.'
},
{
  slug: 'carlsbad',
  city: 'Carlsbad',
  state: 'CA',
  schools: ['Carlsbad High School', 'Sage Creek High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Carlsbad, CA.'
},
{
  slug: 'pearland',
  city: 'Pearland',
  state: 'TX',
  schools: ['Pearland High School', 'Glenda Dawson High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Pearland, TX.'
},
{
  slug: 'rochester-hills',
  city: 'Rochester Hills',
  state: 'MI',
  schools: ['Rochester High School', 'Stoney Creek High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Rochester Hills, MI.'
},
{
  slug: 'broken-arrow',
  city: 'Broken Arrow',
  state: 'OK',
  schools: ['Broken Arrow High School', 'Union High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Broken Arrow, OK.'
},
{
  slug: 'edmond',
  city: 'Edmond',
  state: 'OK',
  schools: ['Edmond Memorial High School', 'Santa Fe High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Edmond, OK.'
},
{
  slug: 'mount-pleasant',
  city: 'Mount Pleasant',
  state: 'SC',
  schools: ['Wando High School', 'Lucy Beckham High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Mount Pleasant, SC.'
},
{
  slug: 'lakewood',
  city: 'Lakewood',
  state: 'CA',
  schools: ['Lakewood High School', 'Mayfair High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Lakewood, CA.'
},
{
  slug: 'vista',
  city: 'Vista',
  state: 'CA',
  schools: ['Rancho Buena Vista High School', 'Vista High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Vista, CA.'
},
{
  slug: 'college-station',
  city: 'College Station',
  state: 'TX',
  schools: ['A&M Consolidated High School', 'College Station High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in College Station, TX.'
},
{
  slug: 'san-ramon',
  city: 'San Ramon',
  state: 'CA',
  schools: ['Dougherty Valley High School', 'California High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in San Ramon, CA.'
},
{
  slug: 'pleasanton',
  city: 'Pleasanton', 
  state: 'CA',
  schools: ['Amador Valley High School', 'Foothill High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Pleasanton, CA.'
},
{
  slug: 'danville',
  city: 'Danville',
  state: 'CA', 
  schools: ['Monte Vista High School', 'San Ramon Valley High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Danville, CA.'
},
{
  slug: 'cupertino',
  city: 'Cupertino',
  state: 'CA',
  schools: ['Cupertino High School', 'Monta Vista High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Cupertino, CA.'
},
{
  slug: 'saratoga',
  city: 'Saratoga',
  state: 'CA',
  schools: ['Saratoga High School', 'Los Gatos High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Saratoga, CA.'
},
{
  slug: 'walnut-creek',
  city: 'Walnut Creek',
  state: 'CA',
  schools: ['Las Lomas High School', 'Northgate High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Walnut Creek, CA.'
},
{
  slug: 'redwood-city',
  city: 'Redwood City',
  state: 'CA',
  schools: ['Sequoia High School', 'Design Tech High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Redwood City, CA.'
},
{
  slug: 'san-mateo',
  city: 'San Mateo',
  state: 'CA',
  schools: ['San Mateo High School', 'Aragon High School'],
  metaDescription: 'Best AI-powered SAT® prep platform in San Mateo, CA.'
},
{
  slug: 'mill-valley',
  city: 'Mill Valley',
  state: 'CA',
  schools: ['Tamalpais High School', 'Marin Academy'],
  metaDescription: 'Best AI-powered SAT® prep platform in Mill Valley, CA.'
},
{
  slug: 'menlo-park',
  city: 'Menlo Park',
  state: 'CA',
  schools: ['Menlo-Atherton High School', 'Menlo School'],
  metaDescription: 'Best AI-powered SAT® prep platform in Menlo Park, CA.'
},
{ slug: "cary", 
  city: "Cary", 
  state: "NC", 
  schools: ["Green Hope High School", "Cary High School", "Cary Academy"], 
  metaDescription: "Best AI-powered SAT® prep platform in Cary, NC.", 
  spotlight: { 
    title: "Academic Excellence in the Research Triangle",
    description: "Located in the Research Triangle, Cary offers a highly educated community and top-performing schools. STEM education is a strong focus, with many programs linked to nearby research universities. Cary’s safe, family-friendly environment contributes to students’ academic success and well-rounded development.", 
    keyPoints: [
      "Consistently ranked among the top school districts in North Carolina",
      "Strong STEM and AP course offerings",
      "Average SAT scores well above the national average",
      "High percentage of students attending competitive in-state and top-tier national universities"
    ] 
  }
   },
   { slug: "carmel", 
    city: "Carmel", 
    state: "IN", 
    schools: ["Carmel High School", "University High School of Indiana", "Guerin Catholic High School"], 
    metaDescription: "Best AI-powered SAT® prep platform in Carmel, IN.", 
    spotlight: {
          title: "Carmel Students Lead in a Culture of Excellence",
          description: "Carmel is known statewide for its top-ranked public schools, enriched academic programs, and high college readiness. With a well-educated population and civic support, students are empowered to succeed beyond high school.",
          keyPoints: [
            "Carmel High School is consistently one of Indiana’s highest-performing schools",
            "Extensive AP and International Baccalaureate offerings",
            "Exceptional music, arts, and academic extracurriculars",
            "College admissions support and high standardized test averages"
          ],
          colleges: [
            {
              name: "Purdue University",
              url: "https://www.purdue.edu/",
              description: "World-renowned public research university in STEM and engineering disciplines."
            },
            {
              name: "Indiana University Bloomington",
              url: "https://www.indiana.edu/",
              description: "Flagship university offering everything from business to international studies."
            },
            {
              name: "Butler University",
              url: "https://www.butler.edu/",
              description: "Private university in nearby Indianapolis with a strong student experience focus."
            },
            {
              name: "Marian University",
              url: "https://www.marian.edu/",
              description: "Catholic liberal arts university with health sciences and teacher education programs."
            }
          ]
        }

     },
     { slug: "fishers", 
      city: "Fishers", 
      state: "IN", 
      schools: ["Fishers High School", "Hamilton Southeastern High School", "Carmel High School"], 
      metaDescription: "Best AI-powered SAT® prep platform in Fishers, IN.", 
      spotlight: {
          title: "Fishers Fosters Academic Growth in a Rapidly Expanding Suburb",
          description: "Fishers combines a fast-growing community with some of Indiana’s highest-rated schools. Students thrive in a forward-thinking district supported by local innovation and strong postsecondary pathways.",
          keyPoints: [
            "Part of the highly rated Hamilton Southeastern School District",
            "Wide access to AP and dual credit courses",
            "Tech-forward community with STEM initiatives",
            "Strong college-going culture across all socioeconomic levels"
          ],
          colleges: [
            {
              name: "Indiana University–Purdue University Indianapolis (IUPUI)",
              url: "https://www.iupui.edu/",
              description: "Urban campus offering a wide variety of degrees just 30 minutes from Fishers."
            },
            {
              name: "Ball State University",
              url: "https://www.bsu.edu/",
              description: "Public research university with nationally ranked education and design programs."
            },
            {
              name: "Butler University",
              url: "https://www.butler.edu/",
              description: "Well-regarded private university with strong liberal arts and business programs."
            },
            {
              name: "Ivy Tech Community College – Indianapolis",
              url: "https://www.ivytech.edu/indianapolis/",
              description: "Indiana’s community college system supporting workforce-ready certifications and transfers."
            }
          ]
        }

       },
       { slug: "sandy-springs", 
        city: "Sandy Springs", 
        state: "GA", 
        schools: ["Riverwood International Charter School", "North Springs Charter High School", "Walton High School"], 
        metaDescription: "Best AI-powered SAT® prep platform in Sandy Springs, GA.", 
        spotlight: { 
          title: "Academic Excellence in Metro Atlanta’s Premier Suburb",
          description: "Sandy Springs offers one of the most well-rounded educational environments in metro Atlanta. With a mix of high-performing public schools and elite private institutions, students across the city benefit from rigorous academics, advanced coursework, and strong college counseling.", 
          keyPoints: [
            "Public and private schools citywide offer extensive AP, IB, and dual enrollment options",
            "Students consistently score above state and national averages on SAT and ACT exams",
            "Strong emphasis on STEM, world languages, and the arts across all grade levels",
            "High college matriculation rates, with many students attending top-tier universities in the Southeast and nationwide"
          ] 
        }
         },
         { slug: "coral-springs", 
          city: "Coral Springs", 
          state: "FL", 
          schools: ["Marjory Stoneman Douglas High School", "J.P. Taravella High School", "Coral Springs High School"], 
          metaDescription: "Best AI-powered SAT® prep platform in Coral Springs, FL.", 
          spotlight: {
            title: "Coral Springs Students Excel in a Community-Focused Environment",
            description: "Coral Springs offers a supportive academic environment rooted in strong public schools, a family-oriented culture, and access to South Florida’s leading universities. Students benefit from advanced academics and a city that values educational excellence.",
            keyPoints: [
              "Strong Broward County schools with advanced course offerings",
              "Safe, suburban atmosphere ideal for focused learning",
              "High participation in AP and dual enrollment programs",
              "Active community partnerships with local colleges and employers"
            ],
            colleges: [
              {
                name: "Florida Atlantic University",
                url: "https://www.fau.edu/",
                description: "A major public university offering robust research and honors programs in nearby Boca Raton."
              },
              {
                name: "Nova Southeastern University",
                url: "https://www.nova.edu/",
                description: "Private research university with a focus on health sciences and dual admissions programs."
              },
              {
                name: "Broward College",
                url: "https://www.broward.edu/",
                description: "Affordable community college offering college credit and technical programs to high schoolers."
              },
              {
                name: "University of Miami",
                url: "https://welcome.miami.edu/",
                description: "Top-ranked private university about an hour away with strong pre-med and business tracks."
              }
            ]
              }
},
          { slug: "stamford", 
          city: "Stamford", 
          state: "CT", 
          schools: ["Stamford High School", "Westhill High School", "King School"], 
          metaDescription: "Best AI-powered SAT® prep platform in Stamford, CT.", 
          spotlight: { 
            title: "Stamford Students Thrive in a Culture of Achievement",
            description: "Stamford combines the resources of a major economic hub with the educational strengths of an affluent New England suburb. With a mix of competitive public and private schools, students across Stamford benefit from rigorous academic programs, a strong college-going culture, and close proximity to some of the country’s top universities. The city's diverse, highly educated population supports a learning environment where academic achievement is both expected and celebrated.", 
            keyPoints: [
              "Strong district-wide focus on college prep and academic achievement",
              "Access to AP, honors, and dual enrollment programs across many schools",
              "Above-average SAT scores and high college acceptance rates",
              "Diverse student body supported by highly educated, engaged families"
            ] 
          }
           },
           {slug: "sugar-land",
            city: "Sugar Land",
            state: "TX",
            schools: ["Clements High School", "Dulles High School", "Fort Bend Christian Academy"],
            metaDescription: "Best AI-powered SAT® prep platform in Sugar Land, TX.",
            spotlight: {
            title: "Excellence in One of Texas’s Most Educated Communities",
            description: "Sugar Land is known for its top-performing schools and highly educated population. As part of the Fort Bend Independent School District, schools across Sugar Land offer strong academics, diverse extracurriculars, and a deep commitment to college preparation. Students benefit from access to advanced coursework and supportive families in a community that consistently ranks among the best places to live and learn in Texas.",
            keyPoints: [
              "High-performing public and private schools across the city",
              "Robust AP, IB, and dual credit offerings at multiple campuses",
              "Strong SAT scores and competitive college admissions results",
              "Supportive, well-educated families that value academic success"
                      ]
                      }
        },
          {slug: "pearland",
          city: "Pearland",
          state: "TX",
          schools: ["Glenda Dawson High School", "Pearland High School", "Robert Turner College and Career High School"],
          metaDescription: "Best AI-powered SAT® prep platform in Pearland, TX.",
          spotlight: {
            title: "College-Ready Academics in Houston’s Top Suburb",
            description: "Pearland offers a high-achieving, family-focused educational environment just outside of Houston. With a growing population and strong public schools, the city emphasizes college preparation through a wide range of advanced programs. Across the district, students benefit from small class sizes, modern facilities, and dedicated educators who support both academic and personal growth.",
            keyPoints: [
              "Consistently strong academic performance across all public high schools",
              "Widespread access to AP, dual credit, and career readiness programs",
              "Above-average SAT scores and growing college matriculation rates",
              "Community-wide commitment to student success and college readiness"
            ]
          }
        },
          {slug: "allen",
          city: "Allen",
          state: "TX",
          schools: ["Allen High School", "Lowery Freshman Center", "Collin College Technical Campus"],
          metaDescription: "Best AI-powered SAT® prep platform in Allen, TX.",
          spotlight: {
  title: "Allen Students Thrive in a Growing Academic Hub",
  description: "Allen blends top-rated schools with access to elite universities, making it an ideal launchpad for college-bound students.",
  keyPoints: [
    "Highly rated public school district with STEM and IB programs",
    "Strong parent and community support for academic achievement",
    "Close proximity to Dallas-Fort Worth metro opportunities",
    "Rapid population growth and investment in education"
            ],
            colleges: [
              {
                name: "The University of Texas at Dallas",
                url: "https://www.utdallas.edu/",
                description: "A public research university known for strong STEM and business programs."
              },
              {
                name: "Southern Methodist University",
                url: "https://www.smu.edu/",
                description: "A private university in Dallas offering liberal arts, business, and engineering."
              },
              {
                name: "Collin College",
                url: "https://www.collin.edu/",
                description: "A local community college with affordable courses and transfer pathways."
              },
              {
                name: "University of North Texas",
                url: "https://www.unt.edu/",
                description: "A large public university with nationally recognized music and education programs."
              }
            ]
          }

        },
          {slug: "richardson",
          city: "Richardson",
          state: "TX",
          schools: ["Richardson High School", "Berkner High School", "Pearce High School", "Dallas International School"],
          metaDescription: "Best AI-powered SAT® prep platform in Richardson, TX.",
          spotlight: {
            title: "High-Achieving Academics in a Diverse, Well-Educated Community",
            description: "Richardson stands out in the Dallas metro area for its strong academic programs, cultural diversity, and emphasis on college preparation. Schools across both Richardson ISD and Plano ISD serve the city, offering students a wide range of AP, IB, and dual credit options. With highly engaged families and a strong pipeline to Texas/’s top universities, Richardson supports student success at every level.",
            keyPoints: [
              "City served by multiple top-performing school districts",
              "Robust advanced coursework available across public and private schools",
              "Consistently strong SAT scores and competitive college admissions",
              "Highly diverse and academically supportive community culture"
            ]
          }
        },
        {slug: "roseville",
        city: "Roseville",
        state: "CA",
        schools: ["Granite Bay High School", "Roseville High School", "Oakmont High School", "Western Sierra Collegiate Academy"],
        metaDescription: "Best AI-powered SAT® prep platform in Roseville, CA.",
        spotlight: {
          title: "College-Focused Learning in Sacramento’s Top Suburb",
          description: "Roseville offers one of the strongest educational environments in the greater Sacramento area. With well-funded schools, a high-performing student population, and strong academic programs, students across Roseville benefit from excellent college prep opportunities. The city's schools emphasize advanced coursework, STEM, and student-centered support systems that lead to consistent academic success.",
          keyPoints: [
            "Multiple highly rated public and charter schools across the city",
            "Strong AP participation and advanced academic tracks available",
            "Above-average SAT scores and high college acceptance rates",
            "Supportive suburban community with excellent school resources"
          ]
        }
      }

];